package com.castly.admin.dto

import kotlinx.serialization.Serializable

@Serializable
data class EpisodeEngagement(
    val isContinueWatching: Boolean,
    val positionSeconds: Int? = null,
    val durationSeconds: Int? = null,
    val progressPercent: Int? = null
)

/**
 * Episode response for public API (Feature 014)
 * Includes parent content context and video metadata when available
 *
 * Frontend copy with String-based UUIDs (Kotlin/JS compatible)
 */
@Serializable
data class EpisodeResponse(
    val id: String,                             // UUID as string
    val contentId: String,                      // Parent content UUID
    val contentType: String,                    // "podcast" | "audiobook"
    val title: String,
    val description: String? = null,
    val imageUrl: String? = null,

    // Episode ordering
    val episodeNumber: Int,
    val seasonNumber: Int? = null,              // Null for audiobooks

    // Audio metadata
    val audioDurationSeconds: Int?,             // Null if duration not available
    val durationMs: Int? = null,               // Duration in milliseconds

    // Video metadata (null if episode has no video)
    val video: VideoObject? = null,

    // Publishing info
    val publishedAt: String,                    // ISO 8601 timestamp
    val createdAt: String,                      // ISO 8601 timestamp
    val updatedAt: String,                      // ISO 8601 timestamp

    // Engagement data (Feature 024) — null when no user or no progress
    val engagement: EpisodeEngagement? = null
)
